module.exports = class PaginationRenderer {
  constructor() {}

  clearCardShells() {
    const container = document.querySelector('#pull-results');

    const cardShells = container.querySelectorAll('.cui-shell-card');

    if (cardShells && cardShells.length) {
      cardShells.forEach(cardShellElement =>
        cardShellElement.parentElement.removeChild(cardShellElement)
      );
    }
  }

  clearPaginatedCards() {
    const container = document.querySelector('#pull-results');

    const browseDeals = container.querySelector('#browse-deals');
    const pagination = container.querySelector('#pull-pagination');

    if (browseDeals) {
      container.removeChild(browseDeals);
    }
    if (pagination) {
      container.removeChild(pagination);
    }
  }

  insertPaginatedCards(cardSlots) {
    cardSlots.forEach((slot, index) => {
      const { cardSlotHtml } = slot;
      const browseContainer = document.querySelector('#pull-results');

      if (browseContainer) {
        if (index) {
          browseContainer.innerHTML += cardSlotHtml;
        } else {
          browseContainer.innerHTML = cardSlotHtml;
        }
      }
    });

    if (window.CardUI) {
      window.CardUI.init();
    }
  }

  insertLazyLoadedCards(cardSlots) {
    const browseContainer = document.querySelector('#pull-results');
    cardSlots.forEach(slot => {
      const { cardSlotHtml } = slot;

      if (browseContainer) {
        browseContainer.insertAdjacentHTML('beforeend', cardSlotHtml);
      }
    });

    if (window.CardUI) {
      window.CardUI.init();
    }
  }

  insertBottomSlot(bottomSlot, shouldAddTopDivider) {
    if (!bottomSlot || !bottomSlot.html) {
      return;
    }

    const bottomSlotContainer = document.querySelector('#pull-bottom-slot');

    if (bottomSlotContainer) {
      if (shouldAddTopDivider) {
        bottomSlotContainer.innerHTML =
          '<hr style="margin-top: 100px; margin-bottom: 60px; width: 100%;">';
      }
      bottomSlotContainer.insertAdjacentHTML('beforeend', bottomSlot.html);
    }

    if (window.CardUI) {
      window.CardUI.init();
    }
  }

  restoreCardsHtmlFromState(cardHtmlSlots = []) {
    if (!cardHtmlSlots.length) {
      return;
    }
    const browseContainer = document.querySelector('#pull-results');
    browseContainer.innerHTML = '';
    cardHtmlSlots.forEach(slot => {
      const { cardSlotHtml } = slot;
      browseContainer.insertAdjacentHTML('beforeend', cardSlotHtml);
    });
    if (window.CardUI) {
      window.CardUI.init();
    }
  }

  restoreBottomWidgetHtmlFromState(cardHtmlSlots = []) {
    if (!cardHtmlSlots.length) {
      return;
    }
    const container = document.querySelector('#pull-bottom-slot');
    container.innerHTML = '';
    cardHtmlSlots.forEach(slot => {
      const { cardSlotHtml } = slot;
      container.insertAdjacentHTML('beforeend', cardSlotHtml);
    });
    if (window.CardUI) {
      window.CardUI.init();
    }
  }

  scrollToTop() {
    const headerPositionElement = document.querySelector('.header-position');
    if (headerPositionElement) {
      headerPositionElement.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    } else if (window.scrollTo) {
      window.scrollTo(0, 0);
    }
  }

  attachPaginationClickHandler(eventHandler) {
    const paginationElements = document.querySelectorAll('.pagination a');

    if (paginationElements && paginationElements.length) {
      paginationElements.forEach(element => {
        element.addEventListener('click', eventHandler);
      });
    }
  }
};
